import React from "react";
import { HStack } from "@chakra-ui/react";
import UiButton from "./UiButton";

export function UiFilterBar(props) {
  return <HStack spacing={2} flexWrap="wrap" {...props} />;
}

export function UiFilterChip({ isActive, ...props }) {
  return (
    <UiButton
      size="sm"
      variant={isActive ? "primary" : "secondary"}
      {...props}
    />
  );
}
